// src/constants/dataTypes.js

export const dmManufacturers = {
  AllDevices: 'All' ,
  QDS: 'QDS meters',
  NonQDS: 'Third-party meters'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
